import { createRoutine } from 'redux-saga-routines';

export const stakePixeosRoutine = createRoutine('pixeos/STAKE_PIXEOS');
export const unStakePixeosRoutine = createRoutine('pixeos/UNSTAKE_PIXEOS');